/**
 * @generated SignedSource<<684e118719ccb022ac91bbe085d36d34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptions_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_user">;
  readonly " $fragmentType": "PdpSharedDescriptionAdditionalOptions_user";
};
export type PdpSharedDescriptionAdditionalOptions_user$key = {
  readonly " $data"?: PdpSharedDescriptionAdditionalOptions_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptions_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2f098ff4cb5258338f85c0ac8112da84";

export default node;
